export const request_url = "https://app-api.bluerock.ro";
export const front_url = "https://app.bluerock.ro";

// export const request_url = "http://localhost:8000";
// export const front_url = "http://localhost:3000";
